  import { Injectable } from "@angular/core";
  import { AnalyticsService } from "../analytics.service";
  import { CommonService } from "../common.service";
  import { UserPreference } from "../../models/UserPreference";
  import { appSettings, errorMessages } from "../../settings";
  import { DateRangeParam } from "../../models/DateRangeParam";
  import { WidgethelperService } from "../widgethelper.service";
  import { OnTimeShipmentParam } from "../../models/OnTimeShipmentParam";
  
  @Injectable()
  export class OntimeshipmentService {
    constructor(
      private _analyticsService: AnalyticsService,
      private _commonService: CommonService,
      private _widgetHelper: WidgethelperService
    ) { }
  
    chartOptions() {
      return {
        title: {
          text: "",
          textStyle: {
            color: "#fff"
          }
        },
        grid: {
          top: '10%'
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["On Time Shipment %"],
          top: '5%',
          textStyle: {
            color: "#fff"
          }
        },
        xAxis: {
          type: "category",
          data: [],
          nameTextStyle: {
            color: "#fff"
          },
          axisLabel: {
            interval: 0,
            length: "100%",
            rotate: 30,
            color: "#fff"
          },
          splitArea: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              interval: 0,
              length: "100%",            
              color: "#fff",
              formatter: '{value} %'
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            splitLine: {
              show: false
            },
          }
        ],
        series: [
          {
            name: "On Time Shipment %",
            type: "bar",
            stack: '1',
            barWidth: '25',
            yAxisIndex:0,
            data: []
          },         
        ]
      };
    }
  
    init(widget: any) {
      console.log("On Time Shipment");
      widget.dataLoaded = false;
      widget.Title = "On Time Shipment";
      let userPref: UserPreference = this._commonService.getUserPreference();
      let criteria: OnTimeShipmentParam = new OnTimeShipmentParam();
      let dateParam: DateRangeParam = new DateRangeParam();
      let setting = widget.widgetsettings;
      (dateParam.RangeValue = this._widgetHelper.GetSummaryType(
        setting.PickType
      ));
      (dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(
        setting.PickType
      ));
  
      this._analyticsService.getDates(dateParam).subscribe(
        data => {
          if (
            data.Start_Date.toString() != "0001-01-01T00:00:00" &&
            data.End_Date.toString() != "0001-01-01T23:59:59.999"
          ) {
            criteria.StartDate = new Date(data.Start_Date);
            criteria.EndDate = new Date(data.End_Date);
            criteria.CustomerId = userPref.CustomerId;
            criteria.FacilityId = userPref.FacilityId;
            criteria.SummaryType = setting.MonitorType;
            console.time("getOnTimeShipment");
            this._analyticsService.getOnTimeShipment(criteria).subscribe(
              (result: any) => {
                console.timeEnd("getOnTimeShipment");
                let Report_Periods = [];
                let ON_TIME_SHIPMENT = [];                                
  
                widget.chartOptions = this.chartOptions();
                widget.errorMessage = null;
                if (result && result.length > 0) {
                  for (let i = 0; i < result.length; i++) {
                    let rptdate = "";
                    if (criteria.SummaryType == "D") {
                      rptdate = this._commonService.formatDate(
                        result[i].REPORT_DATE,
                        appSettings.chartDayFormat
                      );
                    }
                    if (criteria.SummaryType == "W") {
                      rptdate =
                        "Wk " +
                        this._commonService.formatDate(
                          result[i].WEEK_START_DATE,
                          appSettings.chartWeekFormat
                        );
                    }
                    if (criteria.SummaryType == "M") {
                      rptdate = result[i].MONTH_ABBR_NAME;
                    }
                    if (criteria.SummaryType == "Q") {
                      rptdate =
                        result[i].YEAR_NUMBER +
                        " QTR" +
                        result[i].QUARTER_NUMBER;
                    }
                    if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                      Report_Periods.push(rptdate);
                    }  
                    
                    ON_TIME_SHIPMENT.push([rptdate, result[i].ON_TIME_SHIPMENT]);
                  }
                } else {
                  widget.errorMessage = errorMessages.noWidgetData;
                }
                widget.chartOptions.series[0].data = ON_TIME_SHIPMENT;
                widget.chartOptions.xAxis.data = Report_Periods;
                widget.chartOptions.yAxis.max = 100;
                widget.chartOptions.tooltip.formatter = this.tooltipWithPct;
                widget.dataLoaded = true;
              },
              err => {
                console.timeEnd("getOnTimeShipment");
                console.log("getOnTimeShipment", err);
                widget.dataLoaded = true;
                widget.errorMessage = errorMessages.apiError;
              }
            );
          }
        },
        err => {
          console.log("getDates", err);
          widget.dataLoaded = true;
          widget.errorMessage = errorMessages.apiError;
        }
      );
    }
    tooltipWithPct(params): string {
      let tip: string = '';
      if (Array.isArray(params) && params.length > 0) {
        tip = params[0].name + '</br>'
        params.forEach(function (item) {
          tip = tip + '<span style="display:inline-block;margin-right:5px;'
            + 'border-radius:10px;width:9px;height:9px;background-color:'
            + item.color + ';"></span>' + params[0].seriesName.replace('%','') + ' : ' + item.data[1] + '%</br>';
          let val = parseFloat(item.data[1]);
        });
      }
      return tip;
    }
  }
  


// WEBPACK FOOTER //
// ./src/app/services/widgets/ontimeshipment.service.ts